import { Validator, errorMessages } from 'services/validator'
import model from './viewModel'

export default Validator.combineValidators({
  [model.primaryPhone.name]: [
    {
      errorMessage: errorMessages.PRIMARY_PHONE_NUMBER_EMPTY,
      validators: Validator.required()
    },
    {
      errorMessage: errorMessages.PRIMARY_PHONE_NUMBER_INVALID,
      validators: Validator.primaryPhone()
    }
  ]
})
